import { render } from "./WebActivity.vue?vue&type=template&id=55911496&scoped=true"
import script from "./WebActivity.vue?vue&type=script&lang=js"
export * from "./WebActivity.vue?vue&type=script&lang=js"

import "./WebActivity.vue?vue&type=style&index=0&id=55911496&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55911496"]])

export default __exports__